/** Site-wide header links, shared by the desktop nav, its menus and the mobile menu. */
export type NavLink = {
  title: string;
  href: string;
  description?: string;
  external?: boolean;
};

/** Homepage sections; absolute so they work from every page. */
export const hiringLinks: NavLink[] = [
  { title: "How it works", href: "/#how-it-works" },
  { title: "Pricing", href: "/#pricing" },
];

/** Top-level page link after the homepage sections. */
export const eventsLink: NavLink = { title: "Events", href: "/events" };

/** The five event formats, each jumping to its panel on /events. */
export const eventLinks: NavLink[] = [
  {
    title: "Podcast",
    description: "Design leaders, on the record.",
    href: "/events#format-podcast",
  },
  {
    title: "Dinners",
    description: "Small tables, invitation only.",
    href: "/events#format-dinners",
  },
  {
    title: "Founders Breakfasts",
    description: "Founders ask, one guest answers.",
    href: "/events#format-breakfasts",
  },
  {
    title: "Workshops",
    description: "Hands-on, laptops open.",
    href: "/events#format-workshops",
  },
  {
    title: "Meetups",
    description: "Talks, then drinks, at Station F.",
    href: "/events#format-meetups",
  },
];

export const designerLinks: NavLink[] = [
  {
    title: "Apply now",
    description:
      "Join the network and get put forward to teams hiring designers.",
    href: "/join",
  },
  {
    title: "Portfolio review",
    description:
      "A hiring manager's read on your portfolio, with a plan to fix it.",
    href: "/portfolio-review",
  },
  {
    title: "Salary data",
    description: "What product designers earn, by role, level and city.",
    href: "https://data.world-class.design/?mode=salaries",
    external: true,
  },
];

/** True when `href` is the current page (or a page below it). Section and external links never are. */
export const isCurrentPage = (pathname: string, href: string) =>
  !href.startsWith("http") &&
  !href.includes("#") &&
  (pathname === href || pathname.startsWith(`${href}/`));
